import { Button, DatePicker, Form, Input, Select } from 'antd';
import apiBanksCall from 'apps/investcore/apiCalls/bank/list';
import apiFundManagersCall from 'apps/investcore/apiCalls/fund-managers/list';
import { useFetchApiList } from 'hooks/api';
import { useEffect } from 'react';
import { formItemLayout, tailFormItemLayout } from 'utils/formConfig';
import { convertDateFormData, ensureDateFields } from 'utils/formData';

const dateFields = ['inception_date'];

// ETF profile (etf_profiles) edit form. Reads/writes through the nested
// /stocks/{id}/etf-profile endpoint; the base stock fields are edited separately.
const ETFProfileEditForm = ({
  form,
  submiting,
  onFinish,
  initialValues,
  name,
}) => {
  const { data: fundManagers = [], load: loadFundManagers } = useFetchApiList(
    apiFundManagersCall,
    { resourceName: 'data' }
  );

  const { data: banks = [], load: loadBanks } = useFetchApiList(apiBanksCall, {
    resourceName: 'data',
  });

  useEffect(() => {
    loadFundManagers({ page_size: 99 });
    loadBanks({ page_size: 99 });
  }, []);

  useEffect(() => {
    form.setFieldsValue(ensureDateFields(initialValues, dateFields));
  }, [form, initialValues]);

  return (
    <Form
      {...formItemLayout}
      form={form}
      name={name || 'etf_profile_form'}
      onFinish={values => onFinish(convertDateFormData(values, dateFields), [])}
      initialValues={ensureDateFields(initialValues, dateFields)}
      scrollToFirstError
    >
      <Form.Item name="fund_manager_id" label="Fund Manager">
        <Select
          showSearch
          allowClear
          placeholder="Select fund manager"
          optionFilterProp="label"
          options={fundManagers.map(fm => ({
            value: fm.id,
            label: `${fm.name} (${fm.code})`,
          }))}
        />
      </Form.Item>

      <Form.Item
        name="market_index_symbol"
        label="Market Index Symbol"
        tooltip="Symbol of the market index this ETF tracks (e.g. VN30)"
      >
        <Input placeholder="VN30" />
      </Form.Item>

      <Form.Item name="inception_date" label="Inception Date">
        <DatePicker />
      </Form.Item>

      <Form.Item name="strategy" label="Strategy">
        <Input.TextArea rows={20} />
      </Form.Item>

      <Form.Item name="audit_company" label="Audit Company">
        <Input placeholder="" />
      </Form.Item>

      <Form.Item name="trading_schedule" label="Trading Schedule">
        <Input placeholder="" />
      </Form.Item>

      <Form.Item name="trading_method" label="Trading Method">
        <Input placeholder="" />
      </Form.Item>

      <Form.Item name="management_fee" label="Management Fee">
        <Input placeholder="" />
      </Form.Item>

      <Form.Item name="trading_fee" label="Trading Fee">
        <Input placeholder="" />
      </Form.Item>

      <Form.Item name="supervisory_bank_id" label="Supervisory Bank">
        <Select
          showSearch
          allowClear
          optionFilterProp="label"
          placeholder="Select supervisory bank"
          options={(banks || []).map(b => ({
            value: b.id,
            label: `${b.name} (${b.code})`,
          }))}
        />
      </Form.Item>

      <Form.Item name="prospectus_url" label="Prospectus Url">
        <Input placeholder="" />
      </Form.Item>

      <Form.Item {...tailFormItemLayout}>
        <Button type="primary" htmlType="submit" loading={submiting}>
          Save
        </Button>
      </Form.Item>
    </Form>
  );
};

export default ETFProfileEditForm;
